export default __webpack_public_path__ + "static/media/EmptyImageProductDatabase.bd6b58cf.svg";